/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { type ContextValue, useContextProps, useSlottedContext } from 'react-aria-components';
import { SidebarCollapsedStrokeIcon } from '../../icons/sidebar-collapsed-stroke/sidebar-collapsed-stroke.icon';
import { IconButton, type IconButtonProps } from '../icon-button/icon-button.component';
import { VerticalNavigationContext } from '../vertical-navigation/vertical-navigation.component';

const CloseSidebarButtonContext = createContext<ContextValue<IconButtonProps, HTMLButtonElement>>({});

const CloseSidebarButton = forwardRef((props: IconButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
  [props, ref] = useContextProps(props, ref, CloseSidebarButtonContext);

  const verticalNavigationContext = useSlottedContext(VerticalNavigationContext)!;

  return (
    <IconButton
      ref={ref}
      aria-label="Collapse sidebar"
      size={32}
      variant="ghost"
      {...props}
      onPress={() => verticalNavigationContext.onOpenChange!(true)}>
      <SidebarCollapsedStrokeIcon />
    </IconButton>
  );
});

export { CloseSidebarButton, CloseSidebarButtonContext };
